import {HOCModalCenterDesktopPosition} from "components/HOCModalCenterDesktopPosition";
import {PrimaryButton} from "components/PrimaryButton";
import {clearGlobalError, showGageError} from "modules/actions";
import {clearGameMessage, fetchGameMessage} from "modules/actions/gameMessage";
import {setGameMessageViewState} from "modules/actions/user";
import {getErrorsStore, getGameErrorMessage} from "modules/selectors/errors";
import {getGameMessage} from "modules/selectors/gameMessage";
import {getUserStore} from "modules/selectors/user";
import React, {useCallback, useEffect} from "react";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import styled from "@emotion/styled";

const Container = styled.div`
	background: #090b0f;
	margin: auto;
	width: 100%;
	max-width: 80%;
	padding: 35px 0;
`;

const Buttons = styled.div`
	display: flex;
	flex-flow: column;
	align-items: center;
	justify-content: center;
`;

const Title = styled.p`
	font-size: 30px;
	line-height: 28px;
	font-weight: bold;
	text-align: center;
	text-overflow: ellipsis;
`;

export const GameErrors: React.FC = () => {
	const i18n = useTranslation();
	const errorMessage = useSelector(getGameErrorMessage);
	const gameMessage = useSelector(getGameMessage);
	const user = useSelector(getUserStore);
	const {message: globalErrorMessage} = useSelector(getErrorsStore);
	const dispatch = useDispatch();

	const onOffline = useCallback(() => {
		dispatch(showGageError(i18n.t("global.errors.offline")));
	}, []);

	useEffect(() => {
		if (!!user.currentUser && !user.currentUser.isGameMessageViewed) {
			dispatch(fetchGameMessage());
		}
	}, [dispatch, user.currentUser]);

	useEffect(() => {
		if (globalErrorMessage) {
			dispatch(showGageError(i18n.t("global.errors.unknown_error")));
		}
	}, [globalErrorMessage]);

	useEffect(() => {
		window.addEventListener("offline", onOffline);

		return () => {
			window.removeEventListener("offline", onOffline);
		};
	}, [onOffline]);

	const message = gameMessage || errorMessage;

	if (!message || !message.length) {
		return null;
	}

	const onDeny = () => {
		if (gameMessage) {
			dispatch(setGameMessageViewState());
			dispatch(clearGameMessage());
		} else {
			dispatch(clearGlobalError());
		}
	};

	return (
		<HOCModalCenterDesktopPosition
			isOpen={true}
			name={"error"}
			onClose={onDeny}
			headerText={<Title>{i18n.t("global.errors.title", "Error!")}</Title>}
		>
			<Container role="alert" aria-relevant="all">
				<Title>{message}</Title>
				<Buttons>
					<PrimaryButton onClick={onDeny} backgroundColor={"#282F38"}>
						{i18n.t("global.button.okay", "Okay")}
					</PrimaryButton>
				</Buttons>
			</Container>
		</HOCModalCenterDesktopPosition>
	);
};
